export const QUERY_REQUIREMENT = "QUERY_REQUIREMENT";
export const QUERY_REQUIREMENTS_FULL_LIST = "QUERY_REQUIREMENTS_FULL_LIST";
export const QUERY_REQUIREMENTS_FULL_LIST_SIZE =
  "QUERY_REQUIREMENTS_FULL_LIST_SIZE";
export const QUERY_REQUIREMENTS_LIST = "QUERY_REQUIREMENTS_LIST";
